// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C66r","label":"styles_label__21KDj"};